module.exports = __webpack_public_path__ + "img/process.ee6664fb.svg";